import { useState } from "react";
import icon from 'assets/img/icons/welcome-220k.svg'
import { createAPI } from "services/api/api";

const RedeemPrizeConfirm = ({id, value, nextStep, close}) => {

  const [isLoading, setIsLoading] = useState(false);
  const api = createAPI();
  const confirmRequest = () => {
    setIsLoading(true)
    api.post('/claimback/rewards', {id: id})
    .then(() => {
      nextStep('success');
    })
    .catch((error) => {
      console.log('redeem prize failed', error);
      nextStep('fail');
    })
    .finally(() => setIsLoading(false));
  }


  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">You are redeeming a {value} Prize Card!</h5>
        <p className="modal-window__info">The funds will be deposited into your TwoTwentyK account!</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={close}>
          Cancel
        </button>
        <button
          className={`modal-window__footer-submit ${
            isLoading ? "loading" : ""
          }`}
          disabled={isLoading}
          onClick={() => confirmRequest()}
        >
          Redeem
        </button>
      </footer>
    </>
  );
};

export default RedeemPrizeConfirm;
